export function applyHiddenStatusOfSelector(selector) {
  $(selector).each((_index, element) => {
    if (
      $(element).hasClass('timeline-experience-history-hidden') ||
      $(element).hasClass('timeline-experience-lht-hidden') ||
      $(element).hasClass('timeline-searchbar-hidden')
    ) {
      $(element).hide();
    } else {
      $(element).show();
    }
  });
}
